import React from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import parse from 'date-fns/parse';
import subDays from 'date-fns/sub_days';
import addDays from 'date-fns/add_days';

import '../../styles/components/DayModal.css';
import DayGraph from './DayGraph';
import defaultFormatDate from "../../utils/defaultFormatDate";

export default inject('planStore', 'dayStore', 'shiftStore', 'employeeStore')(
  observer(class DayModal extends React.Component {
    constructor(props) {
      super(props);

      this.closeModal = this.closeModal.bind(this);
      this.onEditShiftHandler = this.onEditShiftHandler.bind(this);
      this.previousDay = this.previousDay.bind(this);
      this.nextDay = this.nextDay.bind(this);
    }

    /**
     * Handle closing the modal
     * @return {void}
     */
    closeModal() {
      this.props.dayStore.toggleModal(false);
    }

    onEditShiftHandler(item) {
      // Remove the 'old' shift from the modal
      this.props.shiftStore.closeShift();

      // Start fetching the new shift
      this.props.shiftStore.fetchShift(item.id);

      // Open the shift modal
      this.props.planStore.toggleModal(true);
    }

    previousDay() {
      this.goToDay(-1);
    }

    nextDay() {
      this.goToDay(1);
    }

    goToDay(direction = 1) {
      const currentDay = parse(this.props.dayStore.activeDay);
      const modifierFn = direction === 1 ? addDays : subDays;
      const newDay = defaultFormatDate(modifierFn(currentDay, 1));

      this.props.dayStore.setActiveDay(newDay);
      this.props.employeeStore.fetchEmployees(newDay);
    }

    render() {
      const days = this.props.planStore.days;
      const activeDate = this.props.dayStore.activeDay;

      if (typeof days[activeDate] === 'undefined') {
        this.props.planStore.fetchPlanning(activeDate);
      }

      const day = typeof days[activeDate] !== 'undefined' ? days[activeDate] : null;
      const items = day && day.shifts.length ? day.shifts : [];

      return (
        <div className='daymodal'>
          <Modal
            isOpen={this.props.dayStore.dayModalIsOpen}
            contentLabel="Ploeg modal"
            className="daymodal__modal"
            overlayClassName="daymodal__overlay"
            onRequestClose={() => {
              this.closeModal();
            }}
          >
            <div className="modal-head">
              <div className="modal-head__title">
                {this.props.dayStore.activeDayFormatted}
              </div>

              <div className="modal-buttons">
                <button className="btn btn--white modal__day-prev" onClick={this.previousDay}>
                  Vorige dag
                </button>

                <button className="btn btn--white modal__day-next" onClick={this.nextDay}>
                  Volgende dag
                </button>

                <button className="btn btn--white modal__close" onClick={this.closeModal}>
                  <FontAwesomeIcon icon="times" /> Sluit
                </button>
              </div>
            </div>

            <DayGraph
              day={day}
              items={items}
              onEditShift={this.onEditShiftHandler}
            />
          </Modal>
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/DayModal/DayModal.js